import { render } from "./PopularSinglePost.vue?vue&type=template&id=55cf3637&scoped=true"
import script from "./PopularSinglePost.vue?vue&type=script&lang=js"
export * from "./PopularSinglePost.vue?vue&type=script&lang=js"

import "./PopularSinglePost.vue?vue&type=style&index=0&id=55cf3637&scoped=true&lang=css"

import exportComponent from "D:\\lawstudio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55cf3637"]])

export default __exports__